export default __webpack_public_path__ + "static/video-intro-401a656af89e57c9035acee06bb1c35e.mp4";